import VrsHttp from '@/api/vrs/index'

const vrsHttp = new VrsHttp()

export default class Queue {

    /**
     * 单例
     * @return {?}
     */
    static getInstance() {
        if (!Queue.instance) {
            Queue.instance = new Queue()
        }
        return Queue.instance
    }

    static instance
    requestQueue
    requestTimmer
    synRequestNum
    synNum

    constructor() {
        // 队列
        this.requestQueue = []
        this.requestTimmer = undefined
        this.synRequestNum = 4
        this.synNum = 0
    }

    /**
     * 同步队列 （传入对象必须要有logType，logError）
     * @param log 
     */
    pushToQueue(log) {
        this.requestQueue.push(log)
        return this.onReady(() => {
            this.requestTimmer = this.delay(() => {
                this.clear()
            }, -1)
        })
    }

    /**
     * 宏任务（检测是否有唯一对应值）
     * @param fun 
     */
    onReady(fun) {
        return !!fun ? fun() : null
    }

    /**
     * 执行队列
     * @param fun 
     * @param e 
     */
    delay(fun, e) {
        if (!fun) { return null }
        if (e === -1) {
            return fun()
        }
        setTimeout(fun, e || 0)
    }

    /**
     * 并发限制
     * @return {?}
     */
    clear() {
        let e
        if (this.synNum > this.synRequestNum) {
            clearTimeout(this.requestTimmer)
            return this.requestTimmer = setTimeout(() => {
                this.clear()
            }, 50)
        }
        for (clearTimeout(this.requestTimmer), this.requestTimmer = null; this.synNum < this.synRequestNum && (e = this.requestQueue.pop()); this.synNum++) {
            this.handleLog(e)
        }

        // 执行完如果还有数据则继续执行（放到宏任务）
        if (!!this.requestQueue.length) {
            this.requestTimmer = setTimeout(() => {
                this.clear()
            }, 50)
        }
    }

    /**
     * 清空队列
     * @return {?}
     */
    clearAll() {
        this.requestQueue = []
        this.requestTimmer = null
        this.synNum = 0
    }

    /**
     * 并发数减一
     * @return {?}
     */
    reduceSynNumFun() {
        Queue.instance.synNum--
        return this
    }

    /**
     * 上报
     * @param {*} e logType判断上传接口是哪种类型 pv：上报pv 逻辑 mv：上报mv逻辑 logError：0 代码重新上报次数0次，用int后续方便扩展
     */
    handleLog(e) {
        // 深拷贝避免影响其他数据
        let log = JSON.parse(JSON.stringify(e))
        try {
            vrsHttp.sendVrsLog(log).then((res) => {
                this.reduceSynNumFun()
            }, (error) => {
                this.reduceSynNumFun()
            })


        } catch (err) {
            this.reduceSynNumFun()
        }
    }
}
